import { Grid, Typography } from "@material-ui/core";
import moment from "moment/moment";
import { contractPeriod } from "../../../constants";
import { useContratoServicoService } from "../../context/ContratoServicoContext";

export const ReportHeader = () => {
  const { cachedContracts, filters } = useContratoServicoService();

  const { period } = cachedContracts;

  if (
    filters.period === contractPeriod.Todos ||
    (!period?.startDate && !period?.endDate)
  )
    return (
      <Grid item xs>
        <Typography variant="h4">Relatório de Contratos de Serviço</Typography>

        <Typography variant="subtitle2">
          Apresentanto todo o período da busca
        </Typography>
      </Grid>
    );

  return (
    <Grid item xs>
      <Typography variant="h4">Relatório de Contratos de Serviço</Typography>

      <Typography variant="subtitle2">
        Período da busca:{" "}
        {moment(period?.startDate, filters.period === "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        )}{" "}
        e{" "}
        {moment(period?.endDate, filters.period === "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        )}
      </Typography>
    </Grid>
  );
};
